// Static dummy colors removed — colors come from App Configuration (dynamic REST).

export const cabinetTextures = [];
export const countertopTextures = [];
